import { render, staticRenderFns } from "./AminoAcidModal.vue?vue&type=template&id=146989c6"
import script from "./AminoAcidModal.vue?vue&type=script&lang=js"
export * from "./AminoAcidModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports